import { render, staticRenderFns } from "./portrait-table.vue?vue&type=template&id=29c78e7c&scoped=true&"
import script from "./portrait-table.vue?vue&type=script&lang=ts&"
export * from "./portrait-table.vue?vue&type=script&lang=ts&"
import style0 from "./portrait-table.vue?vue&type=style&index=0&id=29c78e7c&prod&lang=scss&"
import style1 from "./portrait-table.vue?vue&type=style&index=1&id=29c78e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c78e7c",
  null
  
)

export default component.exports